// extracted by mini-css-extract-plugin
module.exports = {"button":"_f5b3bc","icon":"_f03d2e","right":"_99d203"};